import { Link } from "react-router-dom";

const CollectionBox = () => {
  return (
    <>
      <section className="split">
        <div className="ph">
          <img
            alt="Winter ready-to-wear"
            src="/assets/images/winter_ready_to_wear.JPG"
          />
        </div>
        <div className="t">
          <h2 className="serif">Winter Ready-to-Wear</h2>
          <p>
            Premium fabrics paired with embroidered shawls — stitched, tailored
            and ready to wear for evening dinners, festive gatherings and formal
            occasions.
          </p>
          <Link className="btn" to="/shop?category=ready-to-wear">
            Discover
          </Link>
        </div>
      </section>
      <section className="split lav">
        <div className="t">
          <h2 className="serif">Warmth, Worn with Grace</h2>
          <p>
            Pin-tucks, cutwork and needlework details — every piece is finished
            with care.
          </p>
          <Link className="btn" to="/about">
            Our Philosophy
          </Link>
        </div>
        <div className="pair">
          <div className="ph a">
            <img alt="" src="/assets/warmth.jpg" />
          </div>
          <div className="ph b">
            <img alt="" src="/assets/images/warmth2.JPG" />
          </div>
        </div>
      </section>
    </>
  );
};

export default CollectionBox;
